<script setup>
  const props = defineProps(['item', 'isPosition'])
</script>

<template>
  <div
    class="EngineTag"
    :style="{ background: `${props.item?.labelColour}` }"
    :class="{ isPosition: !props.isPosition, None: !props.item?.labelName }"
  >
    {{ props.item?.labelName || '666' }}
  </div>
</template>

<style scoped lang="scss">
  .EngineTag {
    word-break: keep-all;
    display: inline-block;
    padding: 0 4px;
    color: white;
    background: red;
    font-size: 12px;
    height: 18px;
    border-radius: 4px;
  }
  .isPosition {
    position: absolute;
    right: 0;
    transform: translateX(50%);
    top: 0;
  }
  .None {
    display: none !important;
  }
</style>
